import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLanguageContext } from '../context/LanguageContext';
import { translations } from '../translations';
import BookIcon from '@mui/icons-material/Book';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import MusicNoteIcon from '@mui/icons-material/MusicNote';

const Interests = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { language } = useLanguageContext();
  const t = translations[language];

  const getIcon = (iconName) => {
    const iconStyle = {
      fontSize: isMobile ? '2rem' : '2.5rem',
      transition: 'all 0.3s ease-in-out'
    };

    switch (iconName) {
      case 'book':
        return <BookIcon sx={iconStyle} />;
      case 'sports':
        return <SportsSoccerIcon sx={iconStyle} />;
      case 'music':
        return <MusicNoteIcon sx={iconStyle} />;
      default:
        return <BookIcon sx={iconStyle} />;
    }
  };

  return (
    <Box sx={{ 
      py: 8,
      px: { xs: 2, sm: 3 },
      backgroundColor: theme.palette.background.default
    }}>
      <Typography
        variant="h4"
        component="h2"
        gutterBottom
        align="center"
        sx={{ 
          mb: 6,
          fontWeight: 700,
          color: 'text.primary',
          position: 'relative',
          '&:after': {
            content: '""',
            display: 'block',
            width: '80px',
            height: '4px',
            background: theme.palette.primary.main,
            margin: '16px auto 0',
            borderRadius: '2px'
          }
        }}
      >
        {t.interests.title}
      </Typography>
      <Grid 
        container 
        spacing={3} 
        sx={{ 
          maxWidth: '1200px',
          px: { xs: 2, sm: 3 }
        }}
      >
        {t.interests.items.map((interest, index) => (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            md={4} 
            key={interest.name}
            sx={{
              '&:hover': {
                zIndex: 1
              }
            }}
          >
            <Paper
              elevation={3}
              sx={{
                p: 3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: theme.palette.background.paper,
                borderRadius: '12px',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: theme.shadows[8]
                },
                border: `1px solid ${theme.palette.divider}`
              }}
            >
              <Box 
                sx={{ 
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: theme.palette.primary.light + '22',
                  mb: 3,
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.1) rotate(10deg)',
                    backgroundColor: theme.palette.primary.light + '33'
                  },
                  '& svg': {
                    color: theme.palette.primary.main
                  }
                }}
              >
                {getIcon(interest.icon)}
              </Box>
              <Typography
                variant="h6"
                align="center"
                sx={{ 
                  fontWeight: 600,
                  color: 'text.primary',
                  mb: 1,
                  transition: 'color 0.3s ease-in-out'
                }}
              >
                {interest.name}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Interests;
